<template>
  <VForms
    :initial-values="form"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form
        class="reset-password-form"
        @submit.prevent="props.handleSubmit"
      >
        <v-layout column>
          <VTextField
            v-model="props.values.email"
            :error-messages="getEmailErrors(props.errors.email)"
            label="E-mail"
            class="mb-4"
          />
          <v-layout
            row
            wrap
            justify-center
          >
            <VBtn
              color="primary"
              outline
              @click="$router.push({ name: 'LoginPage' })"
            >
              {{ $t('button.return') }}
            </VBtn>
            <VBtn
              color="primary"
              :loading="props.isSubmitting"
              type="submit"
            >
              {{ $t('button.send') }}
            </VBtn>
          </v-layout>
        </v-layout>
      </form>
    </template>
  </VForms>
</template>

<script>
import { Form as VForms } from '@v-forms/core'
import { mapActions } from 'vuex'
import {
  required,
  email,
} from 'vuelidate/lib/validators'
import { ACTION_RESET_PASSWORD } from '../store/types/user.types'

export default {
  name: 'ResetPasswordForm',
  components: {
    VForms,
  },
  data() {
    return {
      form: {
        email: '',
      },
      validations: {
        email: {
          required,
          email,
        },
      },
    }
  },
  methods: {
    async handleSubmit(values, actions) {
      this.resetPassword(values)
      actions.setSubmitting(false)
    },
    getEmailErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      if (values.email) errors.push(this.$t('validates.emailNotValid'))
      return errors
    },
    ...mapActions({
      resetPassword: ACTION_RESET_PASSWORD,
    }),
  },
}
</script>

<style lang="stylus" scoped>
@media only screen and (min-width: 480px) {
  .reset-password-form {
    width: 30em;
  }
}

@media only screen and (max-width: 480px) {
  .reset-password-form {
    padding: 0 2em;
    width: 100%;
  }
  button {
    width: 100%;
  }
}
</style>
